import axiosWrapper from '../helpers/api'
import { ERequestUrl, EMethods } from '../helpers/requests'

export const getReviews = (data) =>
  axiosWrapper({
    method: EMethods.get,
    url: ERequestUrl.reviews,
    uid: `/questions?orderNumber=${data}`,
    hasLocale: false,
  })

export const postReviews = (data) =>
  axiosWrapper({
    method: EMethods.post,
    url: ERequestUrl.reviews,
    data: data,
    hasLocale: false,
  })
